import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Table } from 'antd';


export default (props) => {

    const {
        items = [],
        onPagniationChange,
        onSortChange,
        onDelete,
        pageNo,
        total,
        defaultPageSize,
        showEditModal,
        sortBy,
        sortOrder,
        hasEditAccess = true,
        hasDeleteAccess = true,
    } = props;

    //let navigate = useNavigate();

    const columns = useMemo(() => {

        let titleCol = { defaultSortOrder: undefined }

        const defaultSortOrder = sortOrder === 'ascend' ? 'ascend' : 'descend';

        if (sortBy === 'title') {
            titleCol = { defaultSortOrder }
        }

        return [
            {
                title: 'Age',
                dataIndex: 'label',
                key: 'label',
                sorter: true,
                ...titleCol,
            },
            {
                title: '',
                dataIndex: 'id',
                key: 'id',
                //render: (text, record) => <span>{record.name}</span>
                render: (text, record) => {

                    return (
                        <a
                            data-testid='edit-age'
                            //style={hasEditAccess && record.canEdit ? {} : { color: 'grey', cursor: 'not-allowed' }}
                            //data-can-edit={hasEditAccess && record.canEdit ? 'yes' : ''}
                            onClick={() => {
                                showEditModal && showEditModal({
                                    id: record.id,
                                    age: record.label,
                                    //title: record.title,
                                   // color: record.color,
                                });
                            }}>
                            Edit
                        </a>
                    )
                },
            },
            {
                title: '',
                dataIndex: 'id',
                key: 'id',
                //render: (text, record) => <span>{record.name}</span>
                render: (text, record) => {

                    return (
                        <a
                            data-testid='delete-age'
                           // style={hasDeleteAccess && record.canDelete ? {} : { color: 'grey', cursor: 'not-allowed' }}
                           // data-can-delete={hasDeleteAccess && record.canDelete ? 'yes' : ''}
                            onClick={() => {
                               onDelete && onDelete(record.id, record.title)
                            }}>
                            Delete
                        </a>
                    )
                },
            },
        ]
    }, [sortBy, sortOrder, hasDeleteAccess, hasEditAccess, showEditModal]);


    const onChangeTable = (pagination, filters, sorter, extra) => {
        try {

            // console.log('on change', pagination, filters, sorter, extra);

            if (extra.action === 'paginate') {
                onPagniationChange && onPagniationChange(pagination);
            } else if (extra.action === 'sort') {
                onSortChange && onSortChange(sorter)
            }

        } catch (error) {
            console.log('error on table change', error);
        }
    }

    return (
        <div>
            <Row>
                <Col justify='flex-start' span={24} style={{
                    //padding: '12px',
                    paddingTop: '0px'
                }}>
                    <Table
                        columns={columns}
                        dataSource={items}
                        rowKey={'id'}
                        pagination={{
                            current: pageNo + 1,
                            defaultPageSize,
                            //hideOnSinglePage: true,
                            total,
                        }}
                        onChange={onChangeTable}
                    />
                </Col>
            </Row>
        </div>
    );

}